import { Sun } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SunIcon = createLucideIcon(Sun);
